import CurrentCaseRequired from '../components/ui/current-case-required.js';
import CaseDatabaseCheck from '../components/ui/case-database-check.js';
import EntityOwnershipManager from '../components/ui/EntityOwnershipManager';

export default function EntitiesPage() {
  return (
    <CaseDatabaseCheck>
      <CurrentCaseRequired>
        <EntityOwnershipManager />
      </CurrentCaseRequired>
    </CaseDatabaseCheck>
  );
}
